import type { AppIconProps } from "../IconTypes";

export const ClipboardIcon: React.FC<AppIconProps> = ({
  width,
  height,
  className,
}) => {
  return (
    <svg
      className={className}
      width={width || "16"}
      height={height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.00004 3.33333H4.66671C4.31309 3.33333 3.97395 3.47381 3.7239 3.72386C3.47385 3.97391 3.33337 4.31304 3.33337 4.66667V12.6667C3.33337 13.0203 3.47385 13.3594 3.7239 13.6095C3.97395 13.8595 4.31309 14 4.66671 14H6.66671M6.00004 3.33333C6.00004 2.97971 6.14052 2.64057 6.39057 2.39052C6.64061 2.14048 6.97975 2 7.33337 2H8.66671C9.02033 2 9.35947 2.14048 9.60952 2.39052C9.85956 2.64057 10 2.97971 10 3.33333M6.00004 3.33333C6.00004 3.68696 6.14052 4.02609 6.39057 4.27614C6.64061 4.52619 6.97975 4.66667 7.33337 4.66667H8.66671C9.02033 4.66667 9.35947 4.52619 9.60952 4.27614C9.85956 4.02609 10 3.68696 10 3.33333M12.6667 8V4.66667C12.6667 4.31304 12.5262 3.97391 12.2762 3.72386C12.0261 3.47381 11.687 3.33333 11.3334 3.33333H10M8.66671 11.3333V10.6667C8.66671 10.4899 8.73695 10.3203 8.86197 10.1953C8.98699 10.0702 9.15656 10 9.33337 10H10M12 10H12.6667C12.8435 10 13.0131 10.0702 13.1381 10.1953C13.2631 10.3203 13.3334 10.4899 13.3334 10.6667V11.3333M13.3334 13.3333V14C13.3334 14.1768 13.2631 14.3464 13.1381 14.4714C13.0131 14.5964 12.8435 14.6667 12.6667 14.6667H12M10 14.6667H9.33337C9.15656 14.6667 8.98699 14.5964 8.86197 14.4714C8.73695 14.3464 8.66671 14.1768 8.66671 14V13.3333"
        stroke="#59C69E"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
